import { Injectable } from '@angular/core';
import { AuthService } from '../../../../core';
import { ClienteCentralCompraAuthGuardService } from '../../../pessoa/cliente/central-compra/services';
import { ClienteAuthGuardService } from '../../../pessoa/cliente/services';
import { ClienteAnaliseMercadoRAPClienteOptions, ClienteAnaliseMercadoRAPClienteResponse } from '../adapters';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseMercadoRAPOptionService {

    constructor(private authService: AuthService,
                private clienteAuthGuardService: ClienteAuthGuardService,
                private clienteCentralCompraAuthGuardService: ClienteCentralCompraAuthGuardService) { }

    /** Cria as opções disponíveis nas Análises de Mercado RAP de clientes */
    createClienteOptions(cliente: ClienteAnaliseMercadoRAPClienteResponse): ClienteAnaliseMercadoRAPClienteOptions {
        if (!cliente) {
            return new ClienteAnaliseMercadoRAPClienteOptions();
        }

        const options = new ClienteAnaliseMercadoRAPClienteOptions();
        /** Análise de Mercado */
        options.canOpenAnaliseMercado = true;

        /** Cliente */
        // Abrir cadastro do cliente
        options.canOpenCliente = true;
        // Pré-baixar cliente
        options.canPreBaixarCliente = this.clienteAuthGuardService.canPreBaixar(cliente.cadastro);
        // Baixar cliente
        options.canBaixarCliente = this.clienteAuthGuardService.canBaixar(cliente.cadastro, cliente.situacao, this.authService.isAdministrador(), this.authService.isAtendente(), this.authService.isFinanceiro());

        /** Central de Compras */
        /** Inserir uma nova central de compras */
        options.canInsertCentralCompra = true;
        // Editar central de compras
        options.canEditCentralCompra = this.clienteCentralCompraAuthGuardService.canEdit(cliente.tipoPessoa);
        // Inserir participante em uma central de compras
        options.canInsertParticipanteCentralCompra = this.clienteCentralCompraAuthGuardService.canInsertParticipante(cliente.tipoPessoa, cliente.idClienteCentralCompra);

        return options;
    }
}
